import styled from 'styled-components';
import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';

export const BlockVariation = styled(Block)`
    display: block;
    max-width: 74%;
    flex-basis: 100%;
    padding: 5.5rem 2rem;
    min-height: 442px;
    text-align: center;
`;
export const ContentContainerWrapper = styled.div`
    height: 100%;
    max-width: 1238px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
`;
